import { Inject, Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigInstanceToken, ConfigInterface } from '../../interfaces/config.interface';
import { NavigationEnd, Router } from '@angular/router';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ConfigConstants } from '../../config/config-constants';
import { UserMasterInstanceToken, UserMasterInterface } from '../../interfaces/user-master.interface';

@Component({
    selector: 'pace-core-app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    standalone: false,
})
export class AppHeaderComponent implements OnInit, OnDestroy {
    public gid: string;
    public faUser = faUser;
    public displaySync = true;

    private navigationEndSubscription: Subscription;
    public constructor(
        @Inject(ConfigInstanceToken) private readonly configService: ConfigInterface,
        private readonly router: Router,
        @Inject(UserMasterInstanceToken) private readonly userMasterService: UserMasterInterface,
    ) {
        if (this.userMasterService.isPaceOnlineUser()) {
            this.navigationEndSubscription = this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd))
                .subscribe(() => {
                    this.displaySync = this.router.url.indexOf(ConfigConstants.routeUrlConfirmation) < 0;
                });
        }
    }

    public ngOnInit(): void {
        this.gid = this.configService.getUserFrontId();
    }

    public ngOnDestroy(): void {
        if (typeof this.navigationEndSubscription !== 'undefined') {
            this.navigationEndSubscription.unsubscribe();
        }
    }
}
